// src/components/orders/Orders.js
import React from 'react';
import { useTheme, useMediaQuery } from '@mui/material';
import DesktopOrdersView from './DesktopOrdersView';
import MobileOrdersView from './MobileOrdersView';

const Orders = ({ orders, getOrderItemsSummary }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const getStatusColor = (status) => {
    switch (status) {
      case 'delivered':
        return 'success';
      case 'cancelled':
        return 'error';
      case 'confirmed':
        return 'primary';
      case 'shipped':
        return 'info';
      default:
        return 'warning'; // For 'pending' and any other status
    }
  };

  const getStatusLabel = (status) => {
    const statusMap = {
      'pending': 'قيد الانتظار',
      'confirmed': 'تم التأكيد',
      'shipped': 'تم الشحن',
      'delivered': 'تم التوصيل',
      'cancelled': 'ملغي'
    };
    return statusMap[status] || status;
  };

  return (
    <>
      {isMobile ? (
        <MobileOrdersView 
          orders={orders}
          getOrderItemsSummary={getOrderItemsSummary}
          getStatusColor={getStatusColor}
          getStatusLabel={getStatusLabel}
        />
      ) : (
        <DesktopOrdersView 
          orders={orders}
          getOrderItemsSummary={getOrderItemsSummary}
          getStatusColor={getStatusColor}
          getStatusLabel={getStatusLabel}
        />
      )}
    </>
  );
};

export default Orders;